
import React from 'react';
import { ResponsiveBar } from '@nivo/bar'


export const assignColor = (bar) => {
    const colors = {
        "Pre Open" : '#C8BFE7',
        "Open" : '#8ca9da',
        "Review" : "#A020F0",
        "Closed" : "#ed7d31",
        "Uploaded" : "#a5a5a5",
        "Upload Failed" : "#ffc000",
        "Cancelled" : "#5b9bd5",
        "Total" : "#70ad47"
    }

    return colors[bar.id]
}
//Displaying tooltip for chart
const getTooltip = (data) => {
    return (
        <div style={{
            background: 'white',
            padding: '9px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            fontSize: '14px',
            fontWeight: '500',
            color: '#333'
        }}>
            <div style={{ marginBottom: '4px', fontWeight: '600', color: assignColor(data) }}>
                {data.id}
            </div>
            <div>
                Count: <strong>{data.value}</strong>
            </div>
        </div>
    )
}


const hasData =(data)=>{
    const allKeys = Object.keys(data[0] || {}).filter(key=>key !=='name');
    return data.some(item=>
        allKeys.some(key=> item[key] !==0)
    )

}

const RequestCountBarChart = ({ data }) => (
     <>{data.length ===0 || !hasData(data) ?
        <div style={{display:'flex', justifyContent:"center", alignItems:"center", height:"400px"}}>No records available to display</div>:
    
    <ResponsiveBar
        //configuration for chart
        data={data}
        keys={["Pre Open", "Open", "Review", "Closed","Uploaded","Upload Failed","Cancelled","Total"]}
        //Based on name chart will be grouped
        indexBy="name"
        margin={{ top: 80, right: 0, bottom: 180, left: 30 }}
        padding={0.3}
        colors={assignColor}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        innerPadding={2}
        enableGridY={false}
        enableGridX={false}
        tooltip={getTooltip}
        groupMode="grouped"
        enableLabel={false}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        layers={['grid', 'axes', 'bars', 'markers', 'legends', 'annotations', ({ bars }) => {
            return (
                <g>
                    {bars.map(bar => {
                        if (bar.data.value === 0) return null;
                        return (
                            <text
                                key={bar.key}
                                x={bar.x + bar.width / 2}
                                y={bar.y - 8}
                                textAnchor="middle"
                                dominantBaseline="central"
                                transform={`rotate(-90, ${bar.x + bar.width / 2}, ${bar.y - 8})`}
                                style={{
                                    fill: '#000',
                                    fontSize: '12px',
                                    fontWeight: '500'
                                }}
                            >
                                {bar.data.value}
                            </text>
                        );
                    })}
                </g>
            );
        }]}
        axisLeft={{
            legend: 'REQUEST COUNT',
            tickSize: 5,
            tickPadding: 1,
            tickRotation: 0,
            legendPosition: 'middle',
            legendOffset: -20

        }}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'REQUEST TYPE',
            legendPosition: 'middle',
            legendOffset: 40
        }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: 0,
                translateY: 100,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
    />}</>
)

export default RequestCountBarChart;
